import groq from 'groq'

import { frameBuilderImageFragment } from './image'

const frameBuilderProfileTextureFragment = groq`
  ...,
  gallery[] {
    ...,
    image {
      ${frameBuilderImageFragment}
    },
  },
  "frameProduct": *[
    _type == "product" &&
    locale == $locale &&
    references(^._id)
  ]
  | order(_updatedAt desc)
  [0] {
    _id,
    galleryPhotos[] {
      forOption,
      photos[] {
        ${frameBuilderImageFragment}
      },
    },
  },
`

const frameBuilderProductProfileTextureFragment = groq`
  _id,
  profile,
  texture,
  price,
  discountPercent,
`

export const frameBuilderProfileTextureObjectFragment = groq`
  "profileTextures": *[
    _type == "frameBuilderProfileTexture" &&
    locale == $locale &&
    deactivate != true
  ] {
    ${frameBuilderProfileTextureFragment}
  },
`

export const frameBuilderProductProfileTextureObjectFragment = groq`
  "profileTextures": *[
    _type == "frameBuilderProfileTexture" &&
    locale == $locale &&
    deactivate != true
  ] {
    ${frameBuilderProductProfileTextureFragment}
  },
`
